import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Button } from "antd";

type Permission = { id: number; name: string };
type Admin = {
  student_id: number;
  gender_name: string;
  admission_status_name: string;
  state_name: string;
  zone_name: string;
  branch_name: string;
  orientation_name: string;
  student_class_name: string;
  section_name: string;
  agent_name: string;
  academic_year_name: string;
  varna_student_id: string | null;
  SCS_Number: string;
  is_active: boolean;
  academic_year: number;
  gender: number;
  admission_status: number;
  state: number;
  zone: number;
  branch: number;
  orientation: number;
  student_class: number;
  section: number;
  agent: number;
  button:string;
};

const StudentData = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const data = exam;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
   const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = localStorage.getItem("studentsDataCurrentPage");
    return savedPage ? JSON.parse(savedPage) : 1;
  });
  useEffect(() => {
    localStorage.setItem("studentsDataCurrentPage", JSON.stringify(currentPage));
  }, [currentPage]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  useEffect(() => {
    if (!checkPermission("view", "Can view group")) {
      Cookies.remove("authToken");
      navigate("/login");
    } else {
      fetchData(currentPage, pageSize, searchText);
    }
  }, [userPermissions,currentPage]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string
  ) => {
    const response = await fetch(
      `${webApi}/students/wizklub_student/?page=${page}&pageSize=${pageSize}&search=${searchText}`,
      options
    );
    return await response.json();
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(
      `${webApi}/user/get_permissions_dropdown/`,
      options
    );
    return await resposne.json();
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      setCurrentPage(groupsData.current_page_number);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    fetchData(currentPage, pageSize, value);
  };

  const columns = [
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (_text: any, record: { button: string; student_id: any; no_of_attempts: number }) => (
    //     <div className="d-flex align-items-center">
    //       {checkPermission("change", "Can change group") && (
    //         <Link
    //           className="btn btn-primary"
    //           to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
    //           state={{ id: record.student_id }}
    //         >
    //           {record.button}
    //         </Link>
    //       )}
    //     </div>
    //   ),
    // },
    { title: "SCS Number", dataIndex: "SCS_Number", render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
              <Link
                to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
                state={{ id: record.student_id }}
              >
                {_text}
              </Link>
            ) },
    { title: "Name", dataIndex: "name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "Academic Year", dataIndex: "academic_year_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) }, 
    { title: "Admission Status", dataIndex: "admission_status_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "State", dataIndex: "state_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "Zone", dataIndex: "zone_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "Branch", dataIndex: "branch_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "Orientation", dataIndex: "orientation_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "Class", dataIndex: "student_class_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "Section", dataIndex: "section_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "Agent", dataIndex: "agent_name",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    { title: "No Of Attempts", dataIndex: "no_of_attempts",render: (_text: any, record: { student_id: any; no_of_attempts: number }) => (
      <Link
        to={record.no_of_attempts === 0 ? routes.addWizklubTicket : routes.editWizklubTicket}
        state={{ id: record.student_id }}
      >
        {_text}
      </Link>
    ) },
    
    
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Students Data</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Students Data
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <div className="mb-2">
                {checkPermission("add", "Can add group") && (
                  <Link to={routes.addGroup} className="btn btn-primary">
                    <i className="ti ti-square-rounded-plus-filled me-2" />
                    Add Group
                  </Link>
                )}
              </div> */}
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Students List</h4>
              <div className="d-flex align-items-center flex-wrap"></div>
            </div>
            <div className="card-body p-0 py-3">
              <Table
                columns={columns}
                dataSource={admin}
                Selection={false}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  locale: { items_per_page: "" },
                  nextIcon: <span>Next</span>,
                  prevIcon: <span>Prev</span>,
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "30"],
                 
                }}
                onChange={handleTableChange} // Move this outside of pagination
                onSearch={handleSearch}
              />
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default StudentData;
